import { useState } from 'react'

import { Tooltip, useToggle } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'
import { ArrowCycle, Spinner } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

import { Modals } from 'modules/integrations/components/SyncButton/Modals'
import { useIntegrationsSyncContext } from 'modules/integrations/hooks/SyncContext'

interface SyncButtonProps {
  disabled?: boolean
  tooltipLabel?: string
}

export const SyncButton = ({ disabled = false, tooltipLabel }: SyncButtonProps) => {
  const [showModal, setShowModal] = useState(false)
  const [openTooltip, toggleTooltip] = useToggle(false)
  const { isSyncRunning, syncEnabled, marketplaceIntegration } = useIntegrationsSyncContext()

  if (!syncEnabled || !marketplaceIntegration) return null

  const buttonLabel = i18n.t('integrations.sync_action', {
    integration_name: marketplaceIntegration.name,
  })

  const button = (
    <F0Button
      loading={isSyncRunning}
      icon={isSyncRunning ? Spinner : ArrowCycle}
      label={buttonLabel}
      onClick={() => setShowModal(true)}
      disabled={disabled}
    />
  )

  return (
    <>
      {disabled && tooltipLabel ? (
        <Tooltip.Alt
          attachment="bottom center"
          targetAttachment="top center"
          open={openTooltip}
          toggle={toggleTooltip}
          label={tooltipLabel}
        >
          {button}
        </Tooltip.Alt>
      ) : (
        button
      )}
      {showModal && <Modals setShowModal={setShowModal} />}
    </>
  )
}
